<template>
<div class="chapter">
<div class="inner_page">
<p class="ct" id="d7e1"><b>Top Ten Things about </b><br/><b>Approaching the Paranormal World </b></p>
<p class="pub1" id="d7e174111"><b>1. </b>Read all you can about ghosts, psychics, and hauntings.</p>
<p class="pub1" id="d7e175011"><b>2. </b>Write down any paranormal experiences that you or your family members have had.</p>
<p class="pub1" id="d7e176111"><b>3. </b>Maintain a skeptical but open mind and attitude.</p>
<p class="pub1" id="d7e176811"><b>4. </b>Be prepared to enter uncharted waters.</p>
<p class="pub1" id="d7e177511"><b>5. </b>Keep a journal of your experiences with any sort of psychic experiments involving pendulums, scrying, séances, or any other means of divination.</p>
<p class="pub1" id="d7e179411"><b>6. </b>Sign up for a class to learn from experienced teachers.</p>
<p class="pub1" id="d7e180211"><b>7. </b>Ask questions and follow your instincts.</p>
<p class="pub1" id="d7e180911"><b>8. </b>Respect the research and work that has gone before.</p>
<p class="pub1" id="d7e181711"><b>9. </b>Be prepared to be disappointed sometimes.</p>
<p class="pub1" id="d7e182411"><b>10. </b>Be prepared to be totally amazed!</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Elli_9781605507057_epub_c10_r1.vue?2ec4939f